(() => {
  const label = document.currentScript?.dataset.closeDialog;
  if (!label || window.rdbPrivacyLabelsActive) return;
  window.rdbPrivacyLabelsActive = true;
  const selector = 'button#shopify-pc__prefs__header-close';
  const apply = (button) => {
    if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
  };
  const scan = (node) => {
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    if (node.matches(selector)) apply(node);
    node.querySelectorAll(selector).forEach(apply);
  };
  scan(document.documentElement);
  new MutationObserver((records) => {
    for (const record of records) {
      if (record.type === 'attributes') {
        if (record.target.matches(selector)) apply(record.target);
      } else {
        record.addedNodes.forEach(scan);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-label'] });
})();
